import dynamic from 'next/dynamic';
import Head from 'next/head';
import React from 'react';

import LoadingElement from 'components/common/Loading';
import { wrapper } from 'redux/store';

const NotFoundPage = dynamic(() => import('screen/404'), { ssr: true, loading: () => <LoadingElement /> });

export const getStaticProps = wrapper.getStaticProps(() => async () => ({
	props: {
		title: 'خطا 404',
	},
}));

const Custom404 = (props) => (
	<>
		<Head>
			<title>{props.title}</title>
		</Head>
		<NotFoundPage {...props} />
	</>
);

export default Custom404;
